import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { broadcastAnd, addChat } from "../redux/actions";

const StyledInput = styled.input`
    height:2em;
    background-color:#000;
    color:#fff;
    padding:3px;
`;

class UnconnectedChatForm extends Component {

    constructor(props) {
        super(props);
        this.state = { message: "" };
    }

    sendChat(event) {
        if (this.state.message !== "") {
            this.props.broadcastAnd({
                nick_name: this.props.nick_name,
                room_key: this.props.room_key,
                namespace: "chat",
                action: addChat(this.props.nick_name,this.state.message)
            });
            this.setState({ message: "" });
        }
		event.preventDefault();
    }

    onChange = e => this.setState({ [e.target.name]: e.target.value })

	render() {
		return (
			<div>
				<form onSubmit={this.sendChat.bind(this)}>
                    <div className="field">
                        <div className="control">
                            <StyledInput className="input" type="text" placeholder="Your message" name="message" value={this.state.message} onChange={this.onChange}/>
                        </div>
                    </div>
                </form>
			</div>
		);
	}
}


const mapStateToProps = state => ({ room_key: state.user.room_key, nick_name: state.user.nick_name });
export const ChatForm = connect(mapStateToProps,  { broadcastAnd })(UnconnectedChatForm);



